var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('img',{attrs:{"src":require("./assets/logo.png")}}),_vm._v(" "),_c('ul',[_c('li',[_c('router-link',{attrs:{"to":{name:'home'}}},[_vm._v("首页")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{name:'detail'}}},[_vm._v("详情页")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{name:'list'}}},[_vm._v("列表页")])],1)]),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d8c727a6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = F35p
// module chunks = 3